module.exports = __webpack_public_path__ + "img/cover-iot.1cde70a4.jpg";